// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__3_KxC","ellipsis":"styles_ellipsis__1aFHn"};